import gql from "graphql-tag";
const getCalcRResultQuery = gql(` 
query GetCalcRResult($params: AWSJSON!) {
  getCalcRResult(params: $params) {
    id
    status
    profile
    nearest
    coords
    distance
    geo
    quantity
    filtered
    result
    sampleResult
    groupResult
    mapResult
    meta
    version
  }
}
`)
export default getCalcRResultQuery;
